<div class="button-list-container">
  <div class="map-floating-button" [class.active]="isPopupVisible">
    <button mat-button class="map-top-button" (click)="showPopup($event)">
      <wlm-icon class="vertical-center-icon" icon="scenarios"></wlm-icon>
    </button>
  </div>

  <div *ngIf="isPopupVisible" class="popup-wrapper-container">
    <wlm-map-popup-wrapper [title]="'Scenarios'" [showArrowIcon]="false">
      <ng-container popup-content>
        <wlm-scenarios-selector
          [scenarios]="scenarios"
          [map]="map"
          (scenarioVisibilityChange)="onScenarioVisibilityChange($event)"
        ></wlm-scenarios-selector>
      </ng-container>
    </wlm-map-popup-wrapper>
  </div>
</div>

<!-- [matMenuTriggerFor]="menu"
[disabled]="!scenariosProfiles?.length" -->
